<div class="wrapper" (click)="toggled()">
  <div class="checkbox">
    <div class="checkbox-wrapper">
      <ion-checkbox [checked]="items | allSelected: selected"></ion-checkbox>
    </div>
  </div>
  <div class="listitem">{{ 'multiautocomplete.select_all' | translate }}</div>
</div>
